import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AddNavigationMenu from 'src/components/admin/videos/components/AddNavigationMenu';
import { AddNavigationModel, DeleteNavigationData } from 'src/models/appearanceModel';
import { useAppearanceActions } from 'src/store/appearance/actions';
import { RootState } from 'src/store/reducers/state';
import DeleteNavigationModal from './DeleteNavigation';
import Loader from 'src/components/loader';
import { DragDropContext, Droppable, Draggable, DropResult } from 'react-beautiful-dnd';
import { successMsg } from 'src/components/utilities/utils';
const Navigation = () => {
  const dispatch = useDispatch();
  const appearanceAction = useAppearanceActions(dispatch);
  const [navigationAddFlag, setNavigationAddFlag] = useState<AddNavigationModel>({
    saveFlag: 'Add',
    navigationId: ''
  });
  const [navigationId, setNavigationId] = useState<DeleteNavigationData>({ id: '', name: '' });

  const { navigations, loading, isNavigationDeleted } = useSelector((state: RootState) => {
    return {
      navigations: state.appearance.navigations,
      loading: state.appearance.loading,
      isNavigationDeleted: state.appearance.isNavigationDeleted
    };
  });

  const [items, setItems] = useState(navigations || []);

  useEffect(() => {
    setItems(navigations);
  }, [navigations]);

  const handleChannels = () => {
    setNavigationAddFlag({ saveFlag: 'Add' });
  };

  const handleEdit = (id: string) => {
    setNavigationAddFlag({ saveFlag: 'edit', navigationId: id });
    appearanceAction.getSingleNavigationRequest(id);
  };

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;

    const newItems = Array.from(items);
    const [moved] = newItems.splice(result.source.index, 1);
    newItems.splice(result.destination.index, 0, moved);

    setItems(newItems);
    console.log(newItems);
    const finalPayload =
      newItems &&
      newItems.map((item) => {
        return {
          id: item.id
        };
      });
    appearanceAction.updateNavigationOrderRequest(finalPayload);
  };

  useEffect(() => {
    if (isNavigationDeleted) {
      appearanceAction.getNavigationRequest();
      successMsg('Success');
    }
  }, [isNavigationDeleted]);

  return (
    <>
      <div className="tab-pane fade" id="tabs-navigation" role="tabpanel">
        <div className="p-3">
          <div className="md:flex items-center justify-between mb-5">
            <h6 className="font-semibold mb-0">Navigation Menu</h6>
            <button
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#AddnavigationModal"
              className="btn-primary w-auto mt-0 mr-3 ml-0 borderonly-btn"
              onClick={handleChannels}>
              Add Navigation Menu
            </button>
          </div>

          <div className="overflow-x-auto">
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="navigations">
                {(provided) => (
                  <table
                    className="table-auto w-full border"
                    {...provided.droppableProps}
                    ref={provided.innerRef}>
                    <thead className="text-xs font-semibold uppercase bg-gray-50">
                      <tr>
                        <th className="p-2 text-left">Page</th>
                        <th className="p-2 text-left">URL</th>
                        <th className="p-2 text-left">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="text-sm divide-y divide-gray-100">
                      {loading ? (
                        <Loader />
                      ) : items.length ? (
                        items.map((menu, idx) => (
                          <Draggable key={menu.id} draggableId={menu.id} index={idx}>
                            {(provided) => (
                              <tr ref={provided.innerRef} {...provided.draggableProps}>
                                <td className="p-2">{menu.linkName}</td>
                                <td className="p-2">{menu.linkURL}</td>
                                <td className="p-2">
                                  <div className="flex items-center">
                                    <button
                                      onClick={() => handleEdit(menu.id)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#AddnavigationModal">
                                      <img
                                        src="../../assets/img/icons/edit.svg"
                                        className="w-4 h-4 mr-2"
                                      />
                                    </button>
                                    <button
                                      onClick={() =>
                                        setNavigationId({ id: menu.id, name: menu.linkName })
                                      }
                                      data-bs-toggle="modal"
                                      data-bs-target="#DeleteNavigationModal">
                                      <img
                                        src="../../assets/img/icons/trash.svg"
                                        className="w-4 h-4 mr-2"
                                      />
                                    </button>
                                    <img
                                      src="../../assets/img/icons/tabler_drag-drop.svg"
                                      className="w-4 h-4 cursor-grab"
                                      {...provided.dragHandleProps}
                                    />
                                  </div>
                                </td>
                              </tr>
                            )}
                          </Draggable>
                        ))
                      ) : (
                        <tr>
                          <td>No Data Found</td>
                        </tr>
                      )}
                      {provided.placeholder}
                    </tbody>
                  </table>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        </div>
      </div>

      {/* Add Navigation menu  */}
      <AddNavigationMenu navigationAddFlag={navigationAddFlag} />
      <DeleteNavigationModal navigationId={navigationId.id} />
    </>
  );
};

export default Navigation;
